import React from 'react'
import CascadingSubmenu from './CascadingSubmenu'
import CascadingMenuItem from './CascadingMenuItem'
import { Text } from '../../../shared'
import { INestedMenuItem } from './index'

interface ICascadingMenuItemListProps {
  menuItems: INestedMenuItem[]
  onChange: (id: number) => void
  handleClickAway: () => void
}

const CascadingMenuItemList = ({ menuItems, onChange, handleClickAway }: ICascadingMenuItemListProps) => {
  return (
    <>
      {menuItems.map(({ id, name, clients }) => {
        if (clients) {
          return (
            <CascadingSubmenu
              style={{ zIndex: 10000 }}
              key={'agency_' + id}
              popupId={String(id)}
              title={name}
              // тут выбор агентства
              onClick={() => {
                onChange(id)

                // Это нужно для того, чтобы закрыть dropdown при выборе агентства
                handleClickAway()
              }}
            >
              {/*параметр title в CascadingSubmenu - название агентства */}
              {clients.map(({ id, name }) => (
                <CascadingMenuItem
                  key={id}
                  onClick={(event: any) => {
                    // тут надо не дать всплыть событию выше, так как сработает выбор агентства
                    event.stopPropagation()

                    onChange(id)
                  }}
                >
                  {/* Это расхлоп клиентов агентства. Тут нет агентств и рекламодателей */}
                  <Text size={'sm'}>{name}</Text>
                </CascadingMenuItem>
              ))}
            </CascadingSubmenu>
          )
        }
        return (
          <CascadingMenuItem key={'advertiser_' + id} onClick={() => onChange(id)}>
            {/* тут только рекламодатели без агентств */}
            <Text size={'sm'}>{name}</Text>
          </CascadingMenuItem>
        )
      })}
    </>
  )
}

export default CascadingMenuItemList
